<template>
  <div>
    <b-form-group
      :label="$t('reusable.common.name') + ':'"
      label-for="input-name"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <b-form-input
        id="input-name"
        name="input-name"
        v-model="$v.base_matter_wrapper.name.$model"
        :state="validateState('name')"
        aria-describedby="input-name-live-feedback"
        size="sm"
        class="input-name"
      ></b-form-input>
      <b-form-invalid-feedback id="input-name-live-feedback">{{
        $t("reusable.common.minLength", { min: 3 })
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="$t('reusable.common.description') + ':'"
      label-for="input-description"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <div
        class="form-description mb-2"
        @click="$bvModal.show(`edit-description-modal`)"
      >
        <RenderVHtml
          v-b-tooltip.v-secondary.noninteractive.hover="{
            title: $t('reusable.common.editDescription'),
            boundary: 'viewport',
          }"
          :content="base_matter_wrapper.description"
        ></RenderVHtml>
      </div>
      <ContainerRichTextKlv3
        :id_modal="`edit-description-modal`"
        :title_modal="$t('reusable.common.editDescription')"
        :size_modal="`lg`"
        :object_rich_text="base_matter_wrapper"
        :content_rich_text="base_matter_wrapper.description"
        :show_last_modification="true"
        @save="(content) => patchDescription(base_matter_wrapper, content)"
        @close="$bvModal.hide(`edit-description-modal`)"
      >
      </ContainerRichTextKlv3>
      <!--<b-modal
        :id="`edit-description-modal`"
        title="Editar Descripción"
        size="lg"
        hide-footer
      >
        <NewRichTextEditor
          :Object="base_matter_wrapper"
          :Text="base_matter_wrapper.description"
          @save="patchDescription"
          @close="$bvModal.hide(`edit-description-modal`)"
        ></NewRichTextEditor> 
      </b-modal>-->
      <!-- <b-form-textarea
        id="input-description"
        name="input-description"
        v-model="$v.base_matter_wrapper.description.$model"
        :state="validateState('description')"
        aria-describedby="input-description-live-feedback"
        size="md"
        rows="3"
        max-rows="8"
      ></b-form-textarea> -->
      <b-form-invalid-feedback id="input-description-live-feedback">{{
        $t("reusable.common.minLength", { min: 5 })
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      label-cols="0"
      label-cols-sm="3"
      :label="$t('curricularDefinitions.baseMatterWrapper.initialLevel') + ':'"
      label-for="input-init_level"
      class="label my-2 mx-0"
    >
      <b-form-input
        id="input-init_level"
        v-model="$v.base_matter_wrapper.init_level.$model"
        :state="validateState('init_level')"
        type="number"
        aria-describedby="input-init_level-live-feedback"
        size="sm"
      ></b-form-input>
      <b-form-invalid-feedback id="input-init_level-live-feedback">
        <div
          v-if="base_matter_wrapper.init_level > base_matter_wrapper.end_level"
        >
          {{ $t("curricularDefinitions.baseMatterWrapper.initialLevelError") }}
        </div>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      label-cols="0"
      label-cols-sm="3"
      :label="$t('curricularDefinitions.baseMatterWrapper.finalLevel') + ':'"
      label-for="input-end_level"
      class="label my-2 mx-0"
    >
      <b-form-input
        id="input-end_level"
        v-model="$v.base_matter_wrapper.end_level.$model"
        :state="validateState('end_level')"
        type="number"
        aria-describedby="input-end_level-live-feedback"
        size="sm"
      ></b-form-input>
      <b-form-invalid-feedback id="input-end_level-live-feedback">
        <div
          v-if="base_matter_wrapper.init_level > base_matter_wrapper.end_level"
        >
          {{ $t("curricularDefinitions.baseMatterWrapper.finalLevelError") }}
        </div></b-form-invalid-feedback
      >
    </b-form-group>
    <b-form-group
      label-cols="0"
      label-cols-sm="3"
      :label="
        $getVisibleNames('mesh.formationarea', false, 'Área De Formación') + ':'
      "
      label-for="input-formation-area"
      class="label my-2 mx-0"
    >
      <b-form-select
        id="input-formation-area"
        :options="formationAreas"
        v-model="$v.base_matter_wrapper.formation_area.$model"
        value-field="id"
        text-field="name"
        :state="validateState('formation_area')"
        type="number"
        aria-describedby="input-formation-area-feedback"
        size="sm"
      >
        <template #first>
          <b-form-select-option :value="null"
            >N/A
          </b-form-select-option></template
        ></b-form-select
      >
      <b-form-invalid-feedback id="input-formation-area-feedback"
        >Este campo no puede ser vacío.</b-form-invalid-feedback
      >
    </b-form-group>
    <b-form-group
      label-cols="0"
      label-cols-sm="3"
      :label="
        $getVisibleNames('manual.credits', true, 'Créditos SCT Totales') + ':'
      "
      label-for="input-credits"
      class="label my-2 mx-0"
    >
      <b-form-input
        id="input-credits"
        v-model="$v.base_matter_wrapper.credits.$model"
        :state="validateState('credits')"
        type="number"
        aria-describedby="input-credits-live-feedback"
        size="sm"
      ></b-form-input>
    </b-form-group>
    <!-- <b-form-group
      label="Color"
      label-for="input-color"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <b-form-input
        type="color"
        id="input-color"
        name="input-color"
        v-model="$v.base_matter_wrapper.color.$model"
        :state="validateState('color')"
        aria-describedby="input-color-live-feedback"
        size="md"
        rows="3"
        max-rows="8"
      >
      </b-form-input>
    </b-form-group> -->
    <b-form-group
      label-cols="0"
      label-cols-sm="3"
      :label="
        (institution && institution.internal_use_id == 'duoc.cl'
          ? $t('curricularDefinitions.baseMatterWrapper.pedagogicalHoursTotal')
          : $t('curricularDefinitions.baseMatterWrapper.totalHours')) + ':'
      "
      label-for="input-hours"
      class="label my-2 mx-0"
    >
      <b-form-input
        id="input-hours"
        v-model="$v.base_matter_wrapper.hours.$model"
        :state="validateState('hours')"
        type="number"
        aria-describedby="input-hours-live-feedback"
        size="sm"
        @update="
          () => {
            slotCheckInstitutionalCreditsHour();
          }
        "
      ></b-form-input>
    </b-form-group>
    <!-- Créditos Institucionales -->
    <b-form-group
      v-if="$hasInstitutionalCredits(institution)"
      label-cols="0"
      label-cols-sm="4"
      label-for="input-institutional_credits"
      class="label"
    >
      <template v-slot:label>
        {{
          $getVisibleNames(
            "manual.institutional_credits",
            false,
            "Créditos Institucionales"
          )
        }}
      </template>
      <div id="credit">
        <div class="d-flex">
          <b-badge class="credits-value mb-0" variant="light">
            {{ institutionalCredits }}
          </b-badge>
          <div
            class="toggle-types noprint"
            v-b-tooltip.v-secondary.hover="
              $t('curricularDefinitions.baseMatterWrapper.credit')
            "
          >
            <span
              :class="{
                'font-weight-bold':
                  base_matter_wrapper.use_automatic_institutional_credits,
              }"
              >{{
                $t("curricularDefinitions.baseMatterWrapper.automatic")
              }}</span
            >
            <b-button
              class="check-type"
              @click="
                () => {
                  slotCheckInstitutionalCredits();
                }
              "
              variant="primary"
            >
              <b-icon
                icon="circle-fill"
                class="icon-check"
                :class="{
                  'icon-check-active':
                    !base_matter_wrapper.use_automatic_institutional_credits,
                }"
                scale="0.7"
              ></b-icon>
            </b-button>
            <span
              :class="{
                'font-weight-bold':
                  !base_matter_wrapper.use_automatic_institutional_credits,
              }"
              >{{ $t("curricularDefinitions.baseMatterWrapper.planned") }}</span
            >
          </div>
          <b-form-input
            id="input-institutional_credits"
            type="number"
            min="0"
            class="ml-2"
            :disabled="base_matter_wrapper.use_automatic_institutional_credits"
            v-model="$v.base_matter_wrapper.institutional_credits.$model"
            :state="validateState('institutional_credits')"
            aria-describedby="input-institutional_credits-feedback"
            size="sm"
          ></b-form-input>
          <b-tooltip
            :target="`input-institutional_credits`"
            variant="secondary"
            :noninteractive="true"
          >
            <div v-if="base_matter_wrapper.institutional_credits < 0">
              {{
                $t(
                  "curricularDefinitions.baseMatterWrapper.greaterThanOrEqualToZeroError"
                )
              }}
            </div>
          </b-tooltip>
        </div>
      </div>
    </b-form-group>
    <b-form-group
      :label="$getVisibleNames('teaching.matter', true, 'Asignaturas') + ':'"
      label-for="input-matters"
      label-cols="0"
      label-cols-sm="3"
      class="sm p-0 m-0"
    >
      <b-input-group class="mb-1">
        <b-form-input
          v-model="input_search"
          type="search"
          size="sm"
          :placeholder="
            $t('reusable.common.search') +
            ' ' +
            $getVisibleNames('teaching.matter', true, 'Asignaturas') +
            '...'
          "
        >
        </b-form-input>
        <b-input-group-append>
          <b-button
            :disabled="!input_search"
            @click="input_search = ''"
            size="sm"
            >{{ $t("reusable.common.clear") }}</b-button
          >
        </b-input-group-append>
        <button
          v-can="'teaching.add_matter'"
          @click="$bvModal.show(`new-old-matter-modal`)"
          class="btn-add"
          v-b-tooltip.v-secondary.noninteractive="
            $t('reusable.common.addTooltip', {
              entity: $getVisibleNames('teaching.matter', false, 'Asignaturas'),
            })
          "
        >
          <b-icon font-scale="1" icon="plus-square"></b-icon>
        </button>
      </b-input-group>
      <b-form-select
        v-if="mattersOptions.length > 0"
        id="input-matters"
        v-model="$v.base_matter_wrapper.matters.$model"
        :state="validateState('matters')"
        aria-describedby="input-matters-feedback"
        size="sm"
        multiple
        :select-size="
          searchMatterOptions.length <= 5 ? searchMatterOptions.length + 1 : 15
        "
      >
        <b-form-select-option
          class="select-option"
          v-for="option in searchMatterOptions"
          :key="option.id"
          :value="option.id"
        >
          - {{ option.name }}
        </b-form-select-option>
      </b-form-select>
      <div class="pt-2" v-else>
        {{
          $t("curricularDefinitions.baseMatterWrapper.noElectiveMatters", {
            entity: $getVisibleNames("teaching.matter", true, "Asignaturas"),
          })
        }}
      </div>
      <b-form-invalid-feedback id="input-matters-feedback">{{
        $t("reusable.common.required")
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      v-if="!isNaN(this.base_matter_wrapper.id)"
      label-for="input-modification-date"
      label-cols="0"
      label-cols-sm="0"
      class="p-0 m-0 mt-2"
    >
      <ModificationDate :Information="base_matter_wrapper"></ModificationDate>
    </b-form-group>
    <div class="row mt-3">
      <div
        v-if="show_delete_button && !isNaN(this.base_matter_wrapper.id)"
        class="col"
        style="text-align: left"
      >
        <b-button
          class="mr-1"
          size="sm"
          variant="danger"
          @click="deleteBaseMatterWrapper"
          >{{ $t("reusable.common.delete") }}</b-button
        >
      </div>
      <div v-if="show_save_button" class="col" style="text-align: right">
        <b-button class="m-0 mr-1" size="sm" @click="save">{{
          $t("reusable.common.save")
        }}</b-button>
      </div>
    </div>
    <b-modal
      :id="`new-old-matter-modal`"
      :hide-footer="true"
      :title="
        $t('reusable.common.add') +
        ' ' +
        $getVisibleNames('teaching.matter', false, 'Asignaturas')
      "
      size="lg"
    >
      <OldMatterForm
        :BaseMatterWrapperForm="true"
        @created="createdMatter"
      ></OldMatterForm>
    </b-modal>
  </div>
</template>

<script>
import { generateUniqueId, toast } from "@/utils/utils";
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  minValue,
  numeric,
} from "vuelidate/lib/validators";
import * as names from "@/store/names";
import { mapGetters } from "vuex";
export default {
  name: "BaseMatterWrapperForm",
  mixins: [validationMixin],
  components: {
    // NewRichTextEditor: () => import("@/components/reusable/NewRichTextEditor"),
    OldMatterForm: () => import("@/components/mesh/Matrix2/OldMatterForm"),
    ModificationDate: () => import("@/components/reusable/ModificationDate"),
    ContainerRichTextKlv3: () =>
      import("@/components/reusable/ContainerRichTextKlv3"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
  },
  props: {
    BaseMatterWrapper: {
      type: Object,
      default: function () {
        return {
          id: generateUniqueId(),
          name: "",
          description: "",
          matters: [],
          init_level: 1,
          end_level: 1,
          max_matters: 0,
          formation_area: null,
          credits: 0,
          hours: 0,
          color: "#CBDDE1",
          institutional_credits: 0,
          use_automatic_institutional_credits: false,
          creation_date: null,
          created_by: null,
          updated_by: null,
          update_date: null,
        };
      },
    },
    show_save_button: {
      type: Boolean,
      default: true,
    },
    show_delete_button: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      input_search: "",
      base_matter_wrapper: { ...this.BaseMatterWrapper },
    };
  },
  validations: {
    base_matter_wrapper: {
      name: {
        required,
        minLength: minLength(2),
      },
      description: {},
      init_level: {
        required,
        numeric,
        minValue: minValue(1),
        valid() {
          if (
            this.base_matter_wrapper.init_level <=
            this.base_matter_wrapper.end_level
          )
            return true;
          else return false;
        },
      },
      end_level: {
        required,
        numeric,
        minValue: minValue(1),
        valid() {
          if (
            this.base_matter_wrapper.init_level <=
            this.base_matter_wrapper.end_level
          )
            return true;
          else return false;
        },
      },
      formation_area: {},
      max_matters: {},
      credits: { numeric },
      hours: { numeric },
      color: {},
      matters: {},
      institutional_credits: { minValue: minValue(0) },
      use_automatic_institutional_credits: {},
    },
  },
  computed: {
    ...mapGetters({
      institution: "getInstitution",
      formationAreas: names.FORMATION_AREAS,
      base_matters_wrapper: names.BASE_MATTERS_WRAPPER,
      matters: names.MATTERS,
    }),
    searchMatterOptions() {
      return this.mattersOptions.filter((item) => {
        return (
          this.$filtered(item.name, this.input_search) ||
          this.base_matter_wrapper.matters.includes(item.id)
        );
      });
    },
    // matterDisabled() {
    //   if (!this.egress_profile_id) return [];
    //   let list = [];
    //   const matters = this.base_matters_wrapper.filter(
    //     (x) =>
    //       x.egress_profile == this.egress_profile_id &&
    //       x.id != this.base_matter_wrapper.id
    //   );
    //   matters.forEach((x) => {
    //     list = list.concat(x.matters);
    //   });
    //   return [...new Set(list)];
    // },
    mattersOptions() {
      let list = [];
      list = this.matters.filter((x) => x.is_elective == true);
      return list.sort(function (a, b) {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 0;
      });
    },
    institutionalCredits() {
      // Solo la fórmula DUOC se puede calcular con las horas del envoltorio;
      // las demás (ej. UNAB, que usa semanas) quedan en 0 y se ingresan como "Planificado".
      if (this.$getInstitutionalCreditsFormula(this.institution) == "duoc") {
        // Formula de los créditos institucionales que ocupa DUOC
        const total_pedagogical_hours = this.base_matter_wrapper.hours;
        const credits = Math.round(total_pedagogical_hours / 9);
        return credits ? credits : 0;
      } else return 0;
    },
  },
  methods: {
    patchDescription(object, text) {
      this.base_matter_wrapper.description = text;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.base_matter_wrapper[name];
      return $dirty ? !$error : null;
    },
    createdMatter(matter) {
      this.base_matter_wrapper.matters.push(matter.id);
      this.$bvModal.hide(`new-old-matter-modal`);
    },
    save() {
      this.$v.base_matter_wrapper.$touch();
      if (this.$v.base_matter_wrapper.$anyError) {
        return;
      }
      if (isNaN(this.base_matter_wrapper.id)) {
        this.createBaseMatterWrapper();
      } else this.updateBaseMatterWrapper();
    },
    slotCheckInstitutionalCredits() {
      this.base_matter_wrapper.use_automatic_institutional_credits =
        !this.base_matter_wrapper.use_automatic_institutional_credits;
      if (
        this.base_matter_wrapper.use_automatic_institutional_credits == true
      ) {
        this.base_matter_wrapper.institutional_credits =
          this.institutionalCredits;
      }
    },
    slotCheckInstitutionalCreditsHour() {
      if (
        this.base_matter_wrapper.use_automatic_institutional_credits == true
      ) {
        this.base_matter_wrapper.institutional_credits =
          this.institutionalCredits;
      }
    },
    createBaseMatterWrapper() {
      this.$store
        .dispatch(names.POST_BASE_MATTER_WRAPPER, this.base_matter_wrapper)
        .then((response) => {
          toast(
            String(
              this.$getVisibleNames(
                "mesh.basematterwrapper",
                false,
                "Envoltorio de Asignaturas"
              ) +
                " " +
                this.$t("reusable.common.created")
            )
          );
          this.$emit("created", response);
        });
    },
    updateBaseMatterWrapper() {
      this.$store
        .dispatch(names.UPDATE_BASE_MATTER_WRAPPER, this.base_matter_wrapper)
        .then((response) => {
          toast(
            String(
              this.$getVisibleNames(
                "mesh.basematterwrapper",
                false,
                "Envoltorio de Asignaturas"
              ) +
                " " +
                this.$t("reusable.common.updated")
            )
          );
          this.$emit("updated", response);
        });
    },
    deleteBaseMatterWrapper() {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "mesh.basematterwrapper",
            false,
            "Envoltorio de Asignaturas"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch(
            names.DELETE_BASE_MATTER_WRAPPER,
            this.base_matter_wrapper.id
          );
          this.$emit("deleted", this.base_matter_wrapper);
        }
      });
    },
  },
  created() {},
};
</script>
<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
.form-description {
  width: calc(100%);
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 0.875rem;
  min-height: calc(1.5em + 0.5rem + 2px);
  height: auto;
  max-height: 200px;
  overflow: auto;
  padding: 0.2rem 0.5rem;
  line-height: 1.5;
}
.form-description >>> p {
  margin-bottom: 0.7rem !important;
}
.credits-value {
  margin-left: 0.1em;
  font-size: var(--primary-font-size) !important;
  font-weight: normal;
  line-height: 1;
  max-height: 1.5rem;
  margin-top: 0.2rem;
}
.toggle-types {
  display: flex;
  float: right;
  padding: 0.3em 1.8em;
  border-radius: 3px;
}
.check-type {
  background: #007bff !important;
  margin-inline: 0.7em;
  height: 1.12em;
  width: 2.2em !important;
  margin-top: 2%;
  border-radius: 10px;
}
.check-type-disabled {
  background-image: linear-gradient(
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0.5)
  ) !important;
  margin-inline: 0.7em;
  height: 1.12em;
  width: 2.2em !important;
  margin-top: 2%;
  border-radius: 10px;
}
.icon-check {
  color: white;
  transform: translate(-69%, -50%);
  transition: 0.2s;
}
.icon-check-active {
  transform: translate(15%, -50%) !important;
}
.btn-add {
  border: none;
  background: transparent;
  font-size: 13pt;
  padding: 0;
  margin-left: 0.7rem;
}
.label {
  margin-top: 1%;
}
.input-name {
  margin-top: -1px;
}
select option:disabled {
  font-weight: bold !important;
  background-color: #e9e5e5 !important;
}
#input-color {
  cursor: pointer;
}
.select-option {
  overflow-wrap: break-word;
  white-space: pre-wrap;
  padding: 0 0.25em;
  margin-left: 10px;
  text-indent: -12px;
}
</style>